(function(){
    angular
        .module('appback')
        .directive('ngSimpleresfast', simpleresfast);

        simpleresfast.$inject = ['$timeout'];
        function simpleresfast($timeout){
            return {
              //require: 'ngModel',
              templateUrl: '/backend/resultadopeticion/templateresultados?name=itemsimplefast.twig',
              scope: {
                  //ngModel : '=',
                  peticion: '=',
                  item: '=',
                  rc: '='
                },
              link: function (scope, element, $attrs) {
                return $timeout(function () {
                  //console.log(" simple res");
              });
            }
          }
      }
})();